import { IRootState } from '../reducer'
import { prefix } from './actions'
import { ITaskDetailEntry, taskDetailInitialState } from './reducer'

export const myTasksData = (state: IRootState) => state[prefix].myTasksData
export const myTasksPreviewData = (state: IRootState) => state[prefix].myTasksPreviewData
export const clientTasksData = (state: IRootState) => state[prefix].clientTasksData

export const lastListParams = (state: IRootState) => state[prefix].lastListParams
export const taskDetailsById = (state: IRootState) => state[prefix].taskDetailsById

const LOADING_TASK_DETAIL_ENTRY: ITaskDetailEntry = {
  task: taskDetailInitialState,
  comments: { ...taskDetailInitialState, data: null },
  activity: { ...taskDetailInitialState, data: null },
}

/** One task's task, comments and activity, or loading placeholders until it has an entry. */
export const entryForTask = (
  byId: Record<string, ITaskDetailEntry>,
  taskId: string | null | undefined,
): ITaskDetailEntry => (taskId && byId[taskId]) || LOADING_TASK_DETAIL_ENTRY
export const taskCategories = (state: IRootState) => state[prefix].categories
export const unreadTaskCount = (state: IRootState) => state[prefix].unreadTaskCount
export const liveMyTasksChange = (state: IRootState) => state[prefix].liveMyTasksChange
